import React, { useEffect, useState } from 'react';

declare global {
  interface Window {
    embeddedChatbotConfig?: {
      chatbotId: string;
      domain: string;
    };
  }
}

const ChatbaseChatBot: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadChatWidget = () => {
      const v = document.createElement('script');
      v.type = "text/javascript";
      v.src = "https://www.chatbase.co/embed.min.js";
      v.async = true;
      v.onload = () => {
        try {
          window.embeddedChatbotConfig = {
            chatbotId: "aYIn70M5fc5HnbSlab1rs",
            domain: "www.chatbase.co"
          };
          setIsLoading(false);
        } catch (err) {
          setError('Failed to initialize chat widget');
          setIsLoading(false);
        }
      };
      v.onerror = () => {
        setError('Failed to load chat widget script');
        setIsLoading(false);
      };
      const s = document.getElementsByTagName('script')[0];
      s.parentNode?.insertBefore(v, s);
    };

    loadChatWidget();

    return () => {
      // Cleanup function
      const script = document.querySelector('script[src="https://www.chatbase.co/embed.min.js"]');
      if (script) {
        script.remove();
      }
    };
  }, []);

  if (isLoading) {
    return <div className="chatbot-loading">Loading Chatbase chat bot...</div>;
  }

  if (error) {
    return <div className="chatbot-error">{error}</div>;
  }

  return (
    <div>
      {/* Attach chat widget to a specific container */}
      <div id="chatbot-container" style={{ height: '100vh', width: '100vw' }}></div>
    </div>
  );
};

export default ChatbaseChatBot;